import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgAuthPasswordSeeyes({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 1.65h.1c.32.05.57.3.63.64l.01.1v.84c0 .16-.05.31-.14.44a6.9 6.9 0 013.22.97.84.84 0 01.2-.48l.08-.07.65-.53a.74.74 0 011.04.12l.07.09c.15.27.12.62-.1.87l-.08.07-.65.53a.74.74 0 01-.2.12c.61.53 1.2 1.19 1.8 2 .3.4.3.98 0 1.4-1.9 2.6-3.9 3.7-6.63 3.7-2.72 0-4.73-1.1-6.63-3.7a1.2 1.2 0 010-1.4c.59-.81 1.19-1.47 1.8-2a.73.73 0 01-.2-.12l-.65-.53a.74.74 0 01.93-1.15l.65.53c.17.14.27.34.28.55a6.9 6.9 0 013.23-.97l-.07-.1a.83.83 0 01-.07-.24l-.01-.1V2.4c0-.4.33-.74.74-.74zm0 3.48c-2.2 0-3.75.84-5.3 2.93 1.56 2.08 3.1 2.92 5.3 2.92 2.06 0 3.53-.73 4.98-2.51l.19-.24.13-.17-.13-.18C11.66 5.93 10.15 5.13 8 5.13zm0 .52a2.38 2.38 0 110 4.77 2.38 2.38 0 010-4.77zm0 1.41a.97.97 0 100 1.95.97.97 0 000-1.95z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgAuthPasswordSeeyes.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgAuthPasswordSeeyes.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgAuthPasswordSeeyes svgRef={ref} {...props} />
));
export default ForwardRef;
